








































import Vue from 'vue';
import CloseIcon from '../../assets/img/close.svg';
import PopoverTarget from '@/components/common/PopoverTarget.vue';
export default Vue.extend({
    components: {
        CloseIcon,
        PopoverTarget,
    },
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        minWidth: {
            type: String,
            default: '500px',
        },
        maxWidth: {
            type: String,
            default: '500px',
        },
        hideOnClick: {
            type: String,
            default: 'toggle',
        },
        trigger: {
            type: String,
            default: 'manual',
        },
        placement: {
            type: String,
            default: 'top',
        },
        boundary: {
            type: String,
            default: 'scrollParent',
        },
    },
    data: function() {
        return {
            showAddModal: false,
        };
    },
    methods: {
        show() {
            this.showAddModal = true;
        },
        hide() {
            this.showAddModal = false;
        },
        onHide() {
            this.$emit('on-hide');
        },
        onShow() {
            this.$emit('on-show');
        },
    },
});
